<section class="row mb-4 pl-2 border-left" *ngIf="(capacidadesTecnicas_anterior.length == 0 && capacidadesOperativas_anterior.length == 0)  || authService.getTipoUser() === tipo_prestador; else comparativo">
  <section class="col-sm-12 col-md-6 mb-4 mt-4">
    <h2 class="h6 font-weight-bold mb-2">Capacidad técnica</h2>
    <span *ngIf="capacidadesTecnicas!= null && capacidadesTecnicas.length > 0 ; else sindatos_1">
      <app-tablas [headers]="headersCapacidadTecnica" class="table-responsive overflow" [paginar]="false">
        <tr *ngFor="let item of capacidadesTecnicas" class="small">
          <td>{{item.descripcion_tipo}}</td>
          <td>{{item.descripcion}}</td>
          <td>{{item.cantidad}}</td>
          <td >
            <!-- 27 = Software de alojamiento, Subtipo -->
            {{(item.descripcion_sub_tipo) ? item.descripcion_sub_tipo : 'No Aplica'}}
          </td>
        </tr>
      </app-tablas>
    </span>
    <ng-template #sindatos_1>
      <p class="small">Sin informacion registrada</p>
    </ng-template>
  </section>
  <section class="col-sm-12 col-md-6 mb-2 mt-4">
    <h2 class="h6 font-weight-bold mb-2">Capacidad operativa</h2>
    <span *ngIf="capacidadesOperativas!= null && capacidadesOperativas.length > 0 ; else sindatos_2">
      <app-tablas [headers]="headersCapacidadOperativa" class="table-responsive overflow" [paginar]="false">
        <tr *ngFor="let item of capacidadesOperativas" class="small">
          <td>{{item.descripcion}}</td>
          <td>{{item.numero_empleados}}</td>
        </tr>
      </app-tablas>
    </span>
    <ng-template #sindatos_2>
      <td class="small">Sin informacion registrada</td>
    </ng-template>
  </section>
  <section class="col-sm-12 col-md-12 mb-4 mt-4 border-top">
    <header class="row pt-4">
      <div class="col-sm-12 col-md-6 d-flex flex-row">
        <label class="ml-3 small text-muted mb-0">Categoría<br><strong class="h6 text-dark font-weight-bold">{{informacionEstablecimiento.categoria}}</strong></label>
      </div>
      <div class="col-sm-12 col-md-6">
        <label class="small text-muted mb-0">Sub categoría<br><strong class="h6 text-dark font-weight-bold">{{informacionEstablecimiento.subcategoria}}</strong></label>
      </div>
    </header>
  </section>
</section>

<!-- comparativo -->
<ng-template #comparativo>
  <section class="row mb-4 pl-2 border-left">
    <section class="col-sm-12 col-md-6 mb-4 border-right">
      <h2 class="col-12 h5 font-weight-bold border-actual mt-4">Versión actual</h2>
      <section class="col-sm-12 col-md-12 mb-4">
        <h2 class="h6 font-weight-bold mb-2">Capacidad técnica</h2>
        <span *ngIf="capacidadesTecnicas!= null && capacidadesTecnicas.length > 0 ; else sindatos_1">
          <app-tablas [headers]="headersCapacidadTecnica" class="table-responsive overflow" [paginar]="false">
            <tr *ngFor="let item of capacidadesTecnicas" class="small">
              <td>{{item.descripcion_tipo}}</td>
              <td [class]="item.backColorDescripcion">
                  {{item.descripcion}}
              </td>
              <td [class]="item.backColorCantidad">{{item.cantidad}}</td>
              <td [class]="item.backColorDescripcionSubTipo">
                <!-- 27 = Software de alojamiento, Subtipo -->
                {{(item.descripcion_sub_tipo) ? item.descripcion_sub_tipo : 'No Aplica'}}
              </td>
            </tr>
          </app-tablas>
        </span>
        <ng-template #sindatos_1>
          <p class="small">Sin informacion registrada</p>
        </ng-template>
      </section>

      <section class="col-sm-12 col-md-12 mb-2 mt-4">
        <h2 class="h6 font-weight-bold mb-2">Capacidad operativa</h2>
        <span *ngIf="capacidadesOperativas!= null && capacidadesOperativas.length > 0 ; else sindatos_2">
          <app-tablas [headers]="headersCapacidadOperativa" class="table-responsive overflow" [paginar]="false">
            <tr *ngFor="let item of capacidadesOperativas" class="small">
              <td>{{item.descripcion}}</td>
              <td [class]="item.backColorNumEmpleados">{{item.numero_empleados}}</td>
            </tr>
          </app-tablas>
        </span>
        <ng-template #sindatos_2>
          <td class="small">Sin informacion registrada</td>
        </ng-template>
      </section>

      <section class="col-sm-12 col-md-12 mb-4 mt-4 border-top">
        <header class="row pt-4">
          <div class="col-sm-12 col-md-6 d-flex flex-row">
            <label class="ml-3 small text-muted mb-0">Categoría<br><strong class="h6 text-dark font-weight-bold">{{informacionEstablecimientoActual[0].categoria}}</strong></label>
          </div>
          <div class="col-sm-12 col-md-6">
            <label class="small text-muted mb-0">Sub categoría<br><strong class="h6 text-dark font-weight-bold">{{informacionEstablecimientoActual[0].subcategoria}}</strong></label>
          </div>
        </header>
      </section>
    </section>

    <section class="col-sm-12 col-md-6 mb-4">
      <h2 class="col-12 h5 font-weight-bold border-anterior mt-4">Versión anterior</h2>
      <section class="col-sm-12 col-md-12 mb-4 opacity">
        <h2 class="h6 font-weight-bold mb-2">Capacidad técnica</h2>
        <span *ngIf="capacidadesTecnicas_anterior!= null && capacidadesTecnicas_anterior.length > 0 ; else sindatos_1">
          <app-tablas [headers]="headersCapacidadTecnica" class="table-responsive overflow" [paginar]="false">
            <tr *ngFor="let item of capacidadesTecnicas_anterior" class="small">
              <td>{{item.descripcion_tipo}}</td>
              <td [class]="item.backColorDescripcion">{{item.descripcion}}</td>
              <td [class]="item.backColorCantidad">{{item.cantidad}}</td>
              <td [class]="item.backColorDescripcionSubTipo">
                <!-- 27 = Software de alojamiento, Subtipo -->
                {{(item.descripcion_sub_tipo) ? item.descripcion_sub_tipo : 'No Aplica'}}
              </td>
            </tr>
          </app-tablas>
        </span>
        <ng-template #sindatos_1>
          <p class="small">Sin informacion registrada</p>
        </ng-template>
      </section>

      <section class="col-sm-12 col-md-12 mb-2 mt-4 opacity">
        <h2 class="h6 font-weight-bold mb-2">Capacidad operativa</h2>
        <span *ngIf="capacidadesOperativas_anterior!= null && capacidadesOperativas_anterior.length > 0 ; else sindatos_2">
          <app-tablas [headers]="headersCapacidadOperativa" class="table-responsive overflow" [paginar]="false">
            <tr *ngFor="let item of capacidadesOperativas_anterior" class="small">
              <td>{{item.descripcion}}</td>
              <td [class]="item.backColorNumEmpleados">{{item.numero_empleados}}</td>
            </tr>
          </app-tablas>
        </span>
        <ng-template #sindatos_2>
          <td class="small">Sin informacion registrada</td>
        </ng-template>
      </section>
      <section class="col-sm-12 col-md-12 mb-4 mt-4 border-top opacity">
        <header class="row pt-4">
          <div class="col-sm-12 col-md-6 d-flex flex-row">
            <label class="ml-3 small text-muted mb-0">Categoría<br><strong class="h6 text-dark font-weight-bold">{{informacionEstablecimientoAnterior[0].categoria}}</strong></label>
          </div>
          <div class="col-sm-12 col-md-6">
            <label class="small text-muted mb-0">Sub categoría<br><strong class="h6 text-dark font-weight-bold">{{informacionEstablecimientoAnterior[0].subcategoria}}</strong></label>
          </div>
        </header>
      </section>
    </section>
  </section>
</ng-template>
